// extracted by mini-css-extract-plugin
module.exports = {"widget-container":"WAPreview_widget-container__7MWZG","main-container":"WAPreview_main-container__3sKHu"};